var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("SchedulerDialog", { attrs: { viewModel: _vm.schedulerDialog } }),
      _vm._v(" "),
      _c("div", { staticClass: "text-right align-self-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            staticStyle: { padding: "0.7em 1em" },
            attrs: { type: "button", title: "Open Scheduler (AI Assistant)" },
            on: {
              click: function ($event) {
                return _vm.schedulerDialog.show()
              },
            },
          },
          [
            _c("i", { staticClass: "fa-solid fa-robot fa-lg mr-1" }),
            _vm._v(" Scheduler\n          "),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/enterprise-plan/portfolios/${_vm.workspaceId}/${_vm.strategyId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/enterprise-plan/portfolios/${workspaceId}/${strategyId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("portfolios"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Portfolios" },
            },
            [_c("i", { staticClass: "fa-solid fa-sitemap fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/enterprise-plan/projects/${_vm.workspaceId}/${_vm.strategyId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/enterprise-plan/projects/${workspaceId}/${strategyId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("projects"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Projects" },
            },
            [_c("i", { staticClass: "fa-solid fa-table fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/enterprise-plan/schedule/${_vm.workspaceId}/${_vm.strategyId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/enterprise-plan/schedule/${workspaceId}/${strategyId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("schedule"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Schedule" },
            },
            [_c("i", { staticClass: "fa-regular fa-calendar fa-lg" })]
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "sanitizedHref",
                rawName: "v-sanitizedHref",
                value: `/#/enterprise-plan/pnl/${_vm.workspaceId}/${_vm.strategyId}/${_vm.scenarioId}`,
                expression:
                  "`/#/enterprise-plan/pnl/${workspaceId}/${strategyId}/${scenarioId}`",
              },
            ],
            class: _vm.getButtonClass("pnl"),
            staticStyle: { padding: "0.7em 2em" },
            attrs: { title: "Profit & Loss Report" },
          },
          [_vm._v("\n              P&L\n          ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "sanitizedHref",
                rawName: "v-sanitizedHref",
                value: `/#/enterprise-plan/settings/${_vm.workspaceId}/${_vm.strategyId}/${_vm.scenarioId}`,
                expression:
                  "`/#/enterprise-plan/settings/${workspaceId}/${strategyId}/${scenarioId}`",
              },
            ],
            staticClass: "btn btn-outline-secondary",
            staticStyle: { padding: "0.7em 1em" },
            attrs: { title: "Enterprise Plan Settings" },
          },
          [
            _c("i", {
              staticClass: "fa fa-lg fa-cog",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "sanitizedHref",
                rawName: "v-sanitizedHref",
                value: `/#/enterprise/planning/${_vm.workspaceId}/${_vm.strategyId}`,
                expression:
                  "`/#/enterprise/planning/${workspaceId}/${strategyId}`",
              },
            ],
            staticClass: "btn btn-outline-secondary",
            staticStyle: { padding: "0.7em 1em" },
            attrs: { title: "Back to Enterprise Plans" },
          },
          [_c("i", { staticClass: "fa-solid fa-door-open fa-lg" })]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }